export default __webpack_public_path__ + "static/media/con-assistant.73dddfea.svg";